import { useQuery } from 'react-query';

import { orbitQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useOrbitChatSuggestions() {
  const { get } = useApiHelper();

  const suggestions = useQuery({
    queryKey: orbitQueryKeys.suggestions(),
    queryFn: () =>
      get<IDefaultResponseWithData<string>>('/v1/chat/suggestions').then(
        (res) => res.data.data
      ),
  });

  return {
    suggestions,
  };
}
